import { ActionTaken, From, MessageAuth, MessageInterface, MessageType, TypingPayloadActionType, TypingPayloadInterface } from "@swivl-mono/types";
import React from "react";

import { Config } from "../Config/Config";
import { SwivlChat } from "../SwivlChat";
import { GetTime } from "../helpers/GetTime";
import { ShortId } from "../helpers/UID";
import { LanguageContext, t } from "../i18n/strings";
import "./List.scss";
import { ListItem, ListItemData } from "./ListItem/ListItem";
import { TypingIndicator } from "./ListItem/types/Typing/TypingIndicator";
import LoadPastMessages from "./components/LoadPastMessages";
import { Timestamp } from "./components/Timestamp/Timestamp";
import { addPhoneNumberAndURLLinksForMessage, cleanUpList } from "./helpers/ListHelpers";

export interface ListProps {
  isNewUser: boolean;
  auth?: MessageAuth;
  delegate: SwivlChat;
  hasStarted: boolean;
  isMobile?: boolean;
  isOpen: boolean;
  isConversationTakenOver: boolean;
  width: number;
  height: number;
}
export interface ListState {
  [id: string]: any;
  items: Array<ListItemData>;
  isLoadingPastMessages: boolean;
  hasPastMessages: boolean;
  updateNumber: number; // This is just used to force updates.
}
export interface ListInterface {
  addActionTakenToItemInList(messageId: string, actionTaken: ActionTaken): void;
  addMessagesToList(messages: Array<MessageInterface>): void;
}

export class List extends React.Component<ListProps, ListState> implements ListInterface {
  static contextType = LanguageContext;
  declare context: React.ContextType<typeof LanguageContext>;
  // snapToBottom:boolean = true;
  // scrollInterval:any;
  timestampInterval: any;
  lastUpdate: number;
  isRefreshing: boolean = false;
  // isTouching = false;
  constructor(props: ListProps) {
    super(props);

    this.state = { items: [], isLoadingPastMessages: false, hasPastMessages: !props.isNewUser, updateNumber: 0 };

    this.lastUpdate = Date.now();

    this.props.delegate.list = this;
    this.forceScrollUpdateAfterDelay = this.forceScrollUpdateAfterDelay.bind(this);

    this.onScroll = this.onScroll.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updateForTimestamp = this.updateForTimestamp.bind(this);
    this.resetList = this.resetList.bind(this);
    this.loadPastMessages = this.loadPastMessages.bind(this);
    this.addActionTakenToItemInList = this.addActionTakenToItemInList.bind(this);
    this.addMessagesToList = this.addMessagesToList.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    // this.onTouchStart               = this.onTouchStart.bind(this);
    // this.onTouchEnd                 = this.onTouchEnd.bind(this);
  }
  componentDidMount() {
    // this.scrollInterval  = setInterval(this.scrollToBottom, 1000);
    this.timestampInterval = setInterval(this.updateForTimestamp, 5000);
  }
  componentDidUpdate(prevProps: ListProps, prevState: ListState) {
    this.lastUpdate = Date.now();
  }
  componentWillUnmount() {
    clearInterval(this.timestampInterval);
  }
  onScroll(e: any) {
    // var m2 = 0;
    // if (this.props.isMobile) {
    //   this.snapToBottom = (e.target.scrollTop > 200) ? false : true;
    //   return;
    // }
    // const math = ((e.target.scrollHeight - e.target.scrollTop) - e.target.clientHeight);
    // const offset = (this.props.isMobile && e.target.clientHeight) ? e.target.clientHeight * 0.5 : 200;
    // this.snapToBottom = (math < offset) ? true : false;
  }

  scrollToBottom() {
    // if (this.isRefreshing || (!this.props.isOpen && !this.state.isLoadingPastMessages)) { return; }
    // if (this.snapToBottom ) {
    //         if (this.props.isMobile) {
    //   Scroll.animateScroll.scrollToTop({ duration:200,  isDynamic:true, containerId: "SwivlMessageList" });
    //         } else {
    //        Scroll.animateScroll.scrollToBottom({ duration:200,  isDynamic:true, containerId: "SwivlMessageList" });
    //         }
    //   // if (this.props.isMobile) {
    //   //     // Scroll.animateScroll.scrollToTop({ duration:200,ignoreCancelEvents:true, smooth:'easeInQuad', isDynamic:true, containerId: "SwivlMessageList" });
    //   //     Scroll.animateScroll.scrollToTop({ duration:200,  isDynamic:true, containerId: "SwivlMessageList" });
    //   //     // let objDiv = window.document.getElementById("SwivlMessageList")
    //   //     // objDiv.scrollTop =  0; //objDiv.clientHeight - objDiv.scrollHeight
    //   //     // // objDiv.scrollTo(0,0 - objDiv.scrollHeight - objDiv.clientHeight)
    //   //     // return;
    //   //   } else {
    //   //  Scroll.animateScroll.scrollToBottom({ duration:200,  isDynamic:true, containerId: "SwivlMessageList" });
    //   //   }
    // }
  }
  updateForTimestamp() {
    if (Date.now() - this.lastUpdate > 30 * 1000) {
      this.forceUpdate();
    }
  }

  resetList() {
    this.setState({ items: [], isLoadingPastMessages: false, hasPastMessages: false });
  }

  addActionTakenToItemInList(messageId: string, actionTaken: ActionTaken) {
    let { items } = this.state;
    for (let i = 0; i < items.length; i++) {
      if (items[i].message.uuid == messageId) {
        items[i].message.actionTaken = actionTaken;
        // this.snapToBottom =  true;

        this.setState({ items: items });
        // this.forceScrollUpdateAfterDelay()

        return;
      }
    }
  }
  updateMessage(messageId: string, message: MessageInterface) {
    let items = this.state.items;

    for (let i = 0; i < items.length; i++) {
      if (items[i].message.uuid == messageId) {
        items[i].message = message;
        // this.snapToBottom =  true;

        this.setState({ items: items });
        // this.forceScrollUpdateAfterDelay()

        return;
      }
    }
  }

  addMessagesToList(messages: Array<MessageInterface>, fromInitialLoad?: boolean) {
    let { items } = this.state;
    for (let i = 0; i < messages.length; i++) {
      let message = messages[i];

      if (!this.props.delegate.props.showInvisibles) {
        const isRenderableSystemEvent = this.props.delegate.props.showSystemEvents && message.isSystemEvent;
        if (
          !(
            message.type === MessageType.Text ||
            message.type === MessageType.Buttons ||
            message.type === MessageType.Carousel ||
            message.type === MessageType.LocationPicker ||
            message.type === MessageType.SpacePicker ||
            message.type === MessageType.Media ||
            message.type === MessageType.ProfileCollect ||
            message.type === MessageType.TakeoverEvent ||
            message.type === MessageType.MultiSelect ||
            message.type === MessageType.Typing ||
            isRenderableSystemEvent
          )
        ) {
          continue;
        }
      }

      let wasUpdated = false;
      for (let i = 0; i < items.length; i++) {
        if (items[i].message.uuid == message.uuid) {
          this.updateItemInList(message, items[i]);
          wasUpdated = true;
        }
      }
      if (wasUpdated) {
        continue;
      }

      const sender = (message.from && message.from == From.USER) || message.type == MessageType.CreateUserAndStartConversation ? From.USER : From.BOT;

      const item = addPhoneNumberAndURLLinksForMessage({
        id: ShortId(),
        sender: sender,
        message: message,
        hasTyping: false,
        isHTML: false,
        isActive: false
      });
      // Process Item Typing here?

      items.unshift(item);
    }

    items.sort((a, b) => {
      return GetTime(b.message.createdAt) - GetTime(a.message.createdAt);
    });
    items = cleanUpList(items);
    // if(!supressSnapToBottom) {    this.snapToBottom =  true; }

    if (this.props.delegate.props.onConversationTranscriptUpdate) {
      this.props.delegate.props.onConversationTranscriptUpdate(
        items.map((item) => item.message),
        fromInitialLoad
      );
    }

    if (fromInitialLoad) {
      this.setState({ items }, () => {
        this.props.delegate.scrollToBottomInListWrapper();
      });
    } else {
      this.setState({ items });
    }
  }

  forceScrollUpdateAfterDelay() {
    //   if (this.props.isMobile) {
    //   setTimeout(()=> {
    //     this.snapToBottom =  true;
    //     this.scrollToBottom()
    //     this.setState({updateNumber:this.state.updateNumber + 1})
    //   }, 1000);
    // }
  }

  updateItemInList(newMessage: MessageInterface, item: ListItemData) {
    let items = this.state.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].id == item.id) {
        items[i].message = newMessage;
        items[i] = item;
        this.setState({ items: items });
        // this.forceScrollUpdateAfterDelay()
        return;
      }
    }
  }

  loadTranscript(transcriptDate: Date) {
    this.props.delegate.messageHandler
      .loadTranscript(transcriptDate)
      .then((messages: Array<MessageInterface>) => {
        // this.snapToBottom = true;
        this.addMessagesToList(messages, true);
        if (messages && messages.length && messages.length < 20) {
          this.setState({ hasPastMessages: false });
        }
        setTimeout(() => {
          this.isRefreshing = false;
          // this.snapToBottom = false;

          this.setState({ isLoadingPastMessages: false });
        }, 1000);
      })
      .catch((e) => {
        console.warn("Error Loading Past Messages", e);
      });
  }

  loadPastMessages() {
    this.isRefreshing = true;

    this.setState({ isLoadingPastMessages: true });

    // setTimeout(()=>{
    //   // if (this.props.isMobile) {
    //   //   Scroll.animateScroll.scrollToBottom({ duration:200,  isDynamic:true, containerId: "SwivlMessageList" });
    //   // } else {
    //   //   Scroll.animateScroll.scrollToTop({ duration:200,  isDynamic:true, containerId: "SwivlMessageList" });
    //   // }

    // // let objDiv = window.document.getElementById("SwivlMessageList")
    // // objDiv.scrollTop =  0; //objDiv.clientHeight - objDiv.scrollHeight
    // }, 400);
    let oldest;
    if (
      this.state.items &&
      this.state.items.length &&
      this.state.items[this.state.items.length - 1] &&
      this.state.items[this.state.items.length - 1].message
    ) {
      oldest = this.state.items[this.state.items.length - 1].message;
    }

    this.props.delegate.messageHandler
      .loadPastMessages(oldest)
      .then((messages: Array<MessageInterface>) => {
        // this.snapToBottom = false;
        this.addMessagesToList(messages, false);
        if (messages && messages.length && messages.length < 20) {
          this.setState({ hasPastMessages: false });
        }
        setTimeout(() => {
          this.isRefreshing = false;
          // this.snapToBottom = false;

          this.setState({ isLoadingPastMessages: false });
        }, 1000);
      })
      .catch((e) => console.warn("Error Loading Past Messages", e));
  }
  clearMessages() {
    this.setState({ items: [] });
  }

  typingIndicators(items: ListItemData[], auth?: MessageAuth): any {
    if (!items) {
      return null;
    }
    var toUserOrBot, fromUserOrBot;
    if (auth?.from === From.USER) {
      toUserOrBot = From.USER;
      fromUserOrBot = From.BOT;
    } else {
      toUserOrBot = From.BOT;
      fromUserOrBot = From.USER;
    }

    var hasFromTyping;
    var overrideFromTyping;
    for (let i = 0; i < items.length; i++) {
      //   const element = items[i];

      // }
      // for (let i = items.length - 1; i > 0; i--) {
      const item = items[i];

      if (
        item.sender !== toUserOrBot &&
        item.message.type === MessageType.Typing &&
        item.message.payload &&
        (item.message.payload as TypingPayloadInterface).action == TypingPayloadActionType.Started
      ) {
        if (auth?.from === From.AGENT && item.sender == From.BOT && this.props.isConversationTakenOver) {
          return null;
        }

        return (
          <div className={"scc-ListItem scc-left"} style={{ height: 30 + "px" }}>
            <TypingIndicator isTyping={true} isLeft={true} />
          </div>
        );
      } else if (item.sender !== toUserOrBot) {
        return null;
      }
    }

    return;
  }
  // onTouchStart() { this.isTouching = true; }
  // onTouchEnd() { this.isTouching = false; }

  render() {
    //1584506081664
    //1584506078446 - carousel
    const auth = this.props.delegate.state.auth;
    if (auth || Config.isReadOnly) {
      let list: any = [];
      let emptyList = <></>;

      let now: number = Date.now();
      var items = this.state.items;

      for (let i = 0; i < items.length; i++) {
        let item = items[i];

        list.push(
          <ListItem
            key={item.id}
            item={item}
            auth={auth}
            width={this.props.width}
            height={this.props.height}
            messageHandler={this.props.delegate.messageHandler}
            delegate={this.props.delegate}
          />
        );

        /** Logic to set up the timestamps is calculated on render */

        const thisTime: number = GetTime(item.message.createdAt);

        if (i + 1 < items.length) {
          const prevTime: number = GetTime(items[i + 1].message.createdAt) || GetTime(items[i + 1].message.createdAt);
          if (thisTime && prevTime) {
            if (thisTime - prevTime > 3 * 60 * 1000) {
              list.push(<Timestamp key={"timestamp_" + item.id} time={thisTime} />);
            }
          }
        } else if (now - thisTime > 25 * 1000) {
          /** In the case of the last item, if the time is over x amount, also add a time stamp */
          const thisTime: number = GetTime(item.message.createdAt);
          list.push(<Timestamp key={"timestamp_" + item.id} time={thisTime} />);
        }
      }

      // If we don't have itms show a placeholder
      const isLoading = this.isRefreshing || this.state.isLoadingPastMessages;
      const isEmptyAndNotLoading = items.length === 0 && !isLoading;
      if (isEmptyAndNotLoading) {
        emptyList = (
          <div className="scc-loadPastMessagesText scc-loadPastMessagesTextNotLoading swivl-loadingPastMessages scc-fadeIn">
            {t("noRecentMessages", this.context)}
          </div>
        );
      }

      const typingIndicators = Config.isReadOnly ? null : this.typingIndicators(items, auth);
      // if (typingIndicators) {
      //   list.unshift(typingIndicators);
      // }
      const className = this.props.isMobile ? "scc-messageList scc-isMobile swivl-body" : "scc-messageList swivl-body";
      return isEmptyAndNotLoading ? (
        emptyList
      ) : (
        <div
          className={className}
          id="SwivlMessageList"
          // onScroll={this.onScroll}
          // onTouchStart={this.onTouchStart}
          // onTouchCancel={this.onTouchEnd}
          // onTouchEnd={(this.props.isMobile) ? this.onScroll : null}

          // onScroll={(this.props.isMobile) ? null : this.onScroll}
          // onTouchMove={(this.props.isMobile) ? this.onScroll : null }
        >
          {typingIndicators}
          {list}
          {!Config.hidePastMessages && (
            <LoadPastMessages
              isLoadingPastMessages={this.state.isLoadingPastMessages}
              hasPastMessages={(this.props.hasStarted || this.props.delegate.props.canTakeOver) && this.state.hasPastMessages ? true : false}
              loadPastMessages={this.loadPastMessages}
            />
          )}
        </div>
      );
    } else {
      return <div className="scc-messageList"></div>;
    }
  }
}
